export const Upload2Icon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.96 5.93311C13.36 6.13977 14.34 7.37311 14.34 10.0731V10.1598C14.34 13.1398 13.1467 14.3331 10.1667 14.3331H5.82666C2.84666 14.3331 1.65332 13.1398 1.65332 10.1598V10.0731C1.65332 7.39311 2.61999 6.15977 4.97999 5.93977"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.0003V2.41357"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2333 3.89984L7.99994 1.6665L5.7666 3.89984"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
